import React from "react";
import styled from "styled-components";
import { useTranslation } from "@lib/i18n";
import { func } from "prop-types";
import { motion } from "framer-motion";

import Button from "@components/shared/Button";
import Typography from "@components/shared/Typography";

import { color, tablet } from "@components/shared/utils";
import { getCarImagePath } from "@shared/v2/lib/getCarImagePath";
import { getStaticAssetURL } from "@lib/getStaticAssetURL";

const Container = styled(motion.div)`
  background-color: ${color("lightGrey")};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2rem;
  padding-right: 1.2rem;
  padding-left: 2rem;
`;

const Title = styled(Typography).attrs({
  bold: true,
})`
  margin-bottom: 1rem;
`;

const Content = styled.div`
  flex: 1 1 60%;
`;

const MobileImageWrapper = styled.div`
  flex: 1 1 40%;

  ${tablet`
    display: none;
  `}
`;

const DesktopImageWrapper = styled.div`
  display: none;
  flex: 1 1 40%;

  ${tablet`
    display: block;
  `}
`;

const StyledImage = styled.img`
  width: 100%;
`;

const Body = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
`;

const Description = styled(Typography)`
  flex: 1 0 60%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;

  ${tablet`
    justify-content: flex-start;
  `}
`;

const ThankYouSectionBanner = ({ onThankYouButtonClick }) => {
  const { t } = useTranslation();

  const imageProps = {
    src: getStaticAssetURL(getCarImagePath("P002")),
    alt: t("testDrive.merciSection.car"),
    title: t("testDrive.merciSection.car"),
  };

  return (
    <Container>
      <Content>
        <Title>{t("testDrive.merciSection.highlightedQuestion")}</Title>
        <Body>
          <Description>{t("testDrive.merciSection.text2")}</Description>
          <MobileImageWrapper>
            <StyledImage {...imageProps} />
          </MobileImageWrapper>
        </Body>
        <ButtonWrapper>
          <Button
            data-id="thank-you-button-configure-ami"
            onClick={onThankYouButtonClick}
            inverted
          >
            {t("testDrive.merciSection.buttonText")}
          </Button>
        </ButtonWrapper>
      </Content>
      <DesktopImageWrapper>
        <StyledImage {...imageProps} />
      </DesktopImageWrapper>
    </Container>
  );
};

ThankYouSectionBanner.propTypes = {
  onThankYouButtonClick: func.isRequired,
};

export default ThankYouSectionBanner;
